<template>
  <v-container>
    <v-card-actions>
      <my-leave-application-dialog-create
        :employee-uid="employee.employee_uid"
        @created="loadData"
      />
    </v-card-actions>
    <v-row no-gutters>
      <!-- <v-col
        cols="12"
      >
        <my-leave-entitlement-card-view-list
          ref="entitlement"
          :employee-uid="employee.employee_uid"
        />
      </v-col> -->
      <v-col
        cols="12"
      >
        <my-leave-entitlement-table-list
          ref="entitlement"
          :employee-uid="employee.employee_uid"
        />
      </v-col>
    </v-row>
    <v-row
      v-if="$vuetify.breakpoint.mdAndUp"
      no-gutters
      class="mt-3"
    >
      <v-col cols="12">
        <my-leave-application-table-list
          ref="application"
          :employee-uid="employee.employee_uid"
          @cancelled="loadData"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    components: {
      MyLeaveApplicationDialogCreate: () => import('@/components/hris/my-leave/application/DialogCreate'),
      // MyLeaveEntitlementCardViewList: () => import('@/components/hris/my-leave/entitlement/CardViewList'),
      MyLeaveEntitlementTableList: () => import('@/components/hris/my-leave/entitlement/TableList'),
      MyLeaveApplicationTableList: () => import('@/components/hris/my-leave/application/TableList'),
    },
    metaInfo () {
      return {
        title: 'Leave',        
      }
    },
    computed: {  
      ...mapState({ employee: 'currentEmployee' }),
    },
    methods: {
      loadData () {
        this.$refs.entitlement.loadData()
        this.$refs.application.loadLeaveApplications()
      },
    },
  }
</script>
